import {getOutlet} from 'reconnect.js';
import {getStaffValue} from './StaffUtil';

const ACCESS_LIST = [
  //stg
  //prod
  '63aea7e98ae07b4d5d89cc6f', //Admin
];

const UserOutlet = getOutlet('user');

function permissionRequired(key) {
  const user = UserOutlet.getValue();

  const allowedAccessUser = ACCESS_LIST.some((id) => id === user.username);

  if (allowedAccessUser) {
    return true;
  }

  const defaultValue = user[key] || false;
  const permission = getStaffValue(user.sub, key, defaultValue);

  return permission;
}

export default permissionRequired;

function appendSlashSuffix(pathname) {
  if (pathname[pathname.length - 1] !== '/') {
    return pathname + '/';
  }

  return pathname;
}

export {appendSlashSuffix};
